import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';

import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';
import {TipListDetailsRoutingModule} from './tip-list-details-routing.module';

import {LanguageDropdownModule} from 'shared/language-dropdown/language-dropdown.module';
import {TipListDetailsRepository} from './repositories/tip-list-details.repository';
import {TipListDetailsService} from './services/tip-list-details.service';
import {TipListDetailsComponent} from './tip-list-details.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    TipListDetailsRoutingModule,
    LanguageDropdownModule,
  ],
  declarations: [
    TipListDetailsComponent,
  ],
  providers: [
    TipListDetailsService,
    TipListDetailsRepository,
  ],
})

export class TipListDetailsModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/tip-list/tip-list-details/tip-list-details.module.ts